var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-box"},_vm._l((_vm.bagList),function(item,index){return _c('div',{key:index,staticClass:"card-box-item",on:{"click":function($event){return _vm.goTodDetails(item.packageId)}}},[_c('div',{staticClass:"item-bg"},[_c('img',{attrs:{"src":item.backgroundImage}})]),_c('div',{staticClass:"item-text"},[_c('div',{staticClass:"text-top",style:({
          color:
            item.fontColor == 'black'
              ? 'rgba(0,0,0,0.95)'
              : 'rgba(255,255,255,0.95)',
        })},[_vm._v(" "+_vm._s(item.name)+" ")]),_c('div',{staticClass:"text-center",style:({
          color:
            item.fontColor == 'black'
              ? 'rgba(0,0,0,0.7)'
              : 'rgba(255,255,255,0.7)',
        })},[_vm._v(" "+_vm._s(item.description)+" ")]),_c('div',{staticClass:"text-bottom",style:({
          color:
            item.fontColor == 'black'
              ? 'rgba(0,0,0,0.7)'
              : 'rgba(255,255,255,0.7)',
        })},[_vm._v(" 有效期"+_vm._s(item.expiredTime)+" ")])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }